
<template>

<v-card   >
<v-toolbar   height="42"  color="#273C51" dark flat>
<v-toolbar-title>Добавить сообщества</v-toolbar-title>
<v-spacer></v-spacer> <v-icon @click="close()">mdi-close</v-icon>
</v-toolbar>

<div style="margin:15px">
Сообщества добавляются в фоновом режиме, исключаются сообщества черного списка, а так же сообщества,
которые закрыли участников и ранее добавленные.
</div>

<v-textarea  v-model="grList" color="#4A76A8" solo label="Вставьте ids из буфера обмена"
placeholder="Список ids сообществ через запятую в одну строку или  каждое id с новой строки  (всего можно мониторить до 12 500 сообществ)"
></v-textarea>




</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none" @click="close()" small flat color="#273C51">Отменить</v-btn>
<v-btn style="text-transform:none"  @click="groupsAdd()" small color="#273C51"  class="white--text" ><v-icon>mdi-plus</v-icon> Добавить</v-btn>
</v-card-actions>
</v-card>

</template>

<script>

import axios from 'axios'
export default {
props:['modals' ],
data () {
return{
grList : ""
}
},
methods: {
 close: function(){
   this.modals.addGroups = false

 },

groupsAdd: function(){
this.modals.addGroups = false

axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_add.php', {
method: 'POST',
data: {
list: this.grList
}
})
.then( response => {
this.$store.dispatch('changeCounters')
})
},

},

}
</script>

<style   >

</style>
